export enum MediaType {
  Image = 'image',
  Video = 'video',
  Document = 'document',
}

export interface IMediaMapItem {
  mediaId: string | null
  mediaType: MediaType
  src: string | null
}

export interface IMediaMapFunc<T> {
  (data: T): Map<string, IMediaMapItem>
}

export enum SourceMimeType {
  Jpeg = 'image/jpeg',
  Jpg = 'image/jpg',
  Png = 'image/png',
  Gif = 'image/gif',
  Webp = 'image/webp',
  Svg = 'image/svg+xml',
  Mp4 = 'video/mp4',
  Webm = 'video/webm',
  Ogg = 'video/ogg',
  Quicktime = 'video/quicktime',
  XMsvideo = 'video/x-msvideo',
  XMatroska = 'video/x-matroska',
  Pdf = 'application/pdf',
  Doc = 'application/msword',
  Docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  Xls = 'application/vnd.ms-excel',
  Xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  Txt = 'text/plain',
}

export const MIME_TO_EXTENSION = {
  [SourceMimeType.Jpeg]: 'jpg',
  [SourceMimeType.Jpg]: 'jpg',
  [SourceMimeType.Png]: 'png',
  [SourceMimeType.Gif]: 'gif',
  [SourceMimeType.Webp]: 'webp',
  [SourceMimeType.Svg]: 'svg',
  [SourceMimeType.Mp4]: 'mp4',
  [SourceMimeType.Webm]: 'webm',
  [SourceMimeType.Ogg]: 'ogg',
  [SourceMimeType.Quicktime]: 'mov',
  [SourceMimeType.XMsvideo]: 'x-msvideo',
  [SourceMimeType.XMatroska]: 'x-matroska',
  [SourceMimeType.Pdf]: 'pdf',
  [SourceMimeType.Doc]: 'doc',
  [SourceMimeType.Docx]: 'docx',
  [SourceMimeType.Xls]: 'xls',
  [SourceMimeType.Xlsx]: 'xlsx',
  [SourceMimeType.Txt]: 'txt',
}

export const IMAGE_MIME_TYPES = [
  SourceMimeType.Jpeg,
  SourceMimeType.Jpg,
  SourceMimeType.Png,
  SourceMimeType.Gif,
  SourceMimeType.Webp,
  SourceMimeType.Svg,
] as const

export const VIDEO_MIME_TYPES = [
  SourceMimeType.Mp4,
  SourceMimeType.Webm,
  SourceMimeType.Ogg,
  SourceMimeType.Quicktime,
  SourceMimeType.XMsvideo,
  SourceMimeType.XMatroska,
] as const

export const DOCUMENT_MIME_TYPES = [
  SourceMimeType.Pdf,
  SourceMimeType.Doc,
  SourceMimeType.Docx,
  SourceMimeType.Xls,
  SourceMimeType.Xlsx,
  SourceMimeType.Txt,
] as const

export const MIME_TYPES = {
  [MediaType.Image]: [
    ...IMAGE_MIME_TYPES,
  ],
  [MediaType.Video]: [
    ...VIDEO_MIME_TYPES,
  ],
  [MediaType.Document]: [
    ...DOCUMENT_MIME_TYPES,
  ],
}

export const IMAGE_ACCEPT = IMAGE_MIME_TYPES.join(',')

export const VIDEO_ACCEPT = VIDEO_MIME_TYPES.join(',')

export const MEDIA_ACCEPT = [...IMAGE_MIME_TYPES, ...VIDEO_MIME_TYPES].join(',')

export const DOCUMENT_ACCEPT = DOCUMENT_MIME_TYPES.join(',')

export const KB = 1024
export const MB = KB ** 2
export const GB = KB ** 3

/** Максимальный размер фото при загрузке */
export const MAX_MEDIA_IMAGE_SIZE = 10 * MB
/** Максимальный размер видео при загрузке */
export const MAX_MEDIA_VIDEO_SIZE = 200 * MB
/** Максимальное количество фото/видео при загрузке */
export const MAX_MEDIA_COUNT = 10
/** Максимальный размер документа при загрузке */
export const MAX_MEDIA_DOCUMENT_SIZE = 20 * MB
